/**
 * Created by mqamhieh on 6/25/18.
 * to use with grouped lists set the isGrouped flag, and the items input should look like this
 * [
 *     {
 *         label: 'group1', // should be named label
 *         items: []        // should be named items, same as items in normal usage, i.e: key, text ...etc.
 *     },
 *     {
 *         label: 'group2',
 *         items: []
 *     },
 * ]
 */
(function () {

    "use strict";

    angular
        .module('components')
        .component('hSelectList', {
            controller: HSelectListComponent,
            controllerAs: 'hSelectListComponent',
            bindings: {
                items: '<',
                ngModel: '=',
                loading: '=',
                name: '@',
                hName: '@',
                textKey: '@',
                itemKey: '@',
                descriptionKey: '@',
                placeholder: '@',
                cssClass: '@',
                sortBy: '@',
                multi: '<',
                maxSelectedItemsCount: '<',
                ngChange: '&',
                noClear: '<',
                noSearch: '<',
                ngDisabled: '<',
                showUserAvatar: '<',
                showBreakIcon: '<',
                showIcon: '@',
                showColorIcon: '@',
                searchInitiallyVisible: '<',
                showItemShift:'<',
                isAsync: '<',
                openItems: '<',
                trigger: '<',
                targetElement: '=',
                blockedKeys: '<',
                noneOnAll: '<',
                itemTemplate: '<',
                selectedItemTemplate: '<',
                selectNone: '<',
                arrowIcon: '@',
                showSelectedCount: '<',
                countLabel: '@',
                direction: '@',
                hideSelectAll: '<',
                currency:'@',
                truncate: '<',
                isGrouped: '<',
                onOpenStateChange: '&',
                groupLabelClass: '@',
                isPaginated: '<',
                isSearching: '<',
                onReachBottom: '&',
                appendTo: '<'
            },
            templateUrl: '../hmodules/components/h-select-list/h-select-list.component.ng.html'
        });

    HSelectListComponent.$inject = ['$element', '$scope', '$q', '$timeout', 'TSUsersService', 'TeamScheduleService'];

    function HSelectListComponent($element, $scope, $q, $timeout, TSUsersService, TeamScheduleService) {

        var self = this;
        var prevModel;
        let menuElm;
        let skipClickEvent = false;

        self.$onInit = function () {
            self.name = self.name || self.hName;
            self.search = '';
            self.isOpen = self.openItems || false;
            self.arrowIcon = self.arrowIcon || "fa-chevron";
            prevModel = self.ngModel;
            self.isLoadingMore = false;

            $element = self.targetElement || $element;

            if (self.showUserAvatar) {
                loadUsersAvatars();
            }

            sortItems();
            updateVisibleItems();
        };

        self.$doCheck = function () {
            if ((prevModel && !self.ngModel) || (self.ngModel && !prevModel)) {
                matchSelectedWithModel();
                self.viewTrigger = !self.viewTrigger;
            }

            prevModel = self.ngModel;
        };

        self.$onChanges = function (changeObj) {
            if (changeObj.items || changeObj.ngModel || changeObj.trigger) {
                if (
                    changeObj.items &&
                    !changeObj.items.isFirstChange() &&
                    JSON.stringify(changeObj.items.currentValue) !== JSON.stringify(self.items)
                ) {
                    self.items = angular.copy(changeObj.items.currentValue);
                }

                if (!self.items || (!self.isGrouped && self.items.indexOf(self.ngModel) === -1) || (self.isGrouped && self.items.every(function (group) {
                    return group.items.indexOf(self.ngModel) === -1;
                }))) {
                    matchSelectedWithModel();
                    if (!self.isPaginated || changeObj.isSearching) {
                        $element.find(".inner-list").scrollTop(0);
                    }
                }

                if (self.items && self.showUserAvatar) {
                    loadUsersAvatars();
                }

                sortItems();
                updateVisibleItems();

                if (self.multi) {
                    updateAllSelected();
                }
            }

            if (
                changeObj.hName &&
                !changeObj.hName.isFirstChange() &&
                JSON.stringify(changeObj.hName.currentValue) !== JSON.stringify(changeObj.hName.previousValue)
            ) {
                this.name = this.hName;
            }

            if (
                changeObj.openItems &&
                !changeObj.openItems.isFirstChange() &&
                JSON.stringify(changeObj.openItems.currentValue) !== JSON.stringify(changeObj.openItems.previousValue)
            ) {
                self.isOpen = angular.copy(changeObj.openItems.currentValue);
                self.onOpenStateChange && self.onOpenStateChange({isOpen: self.isOpen});
            }
        };

        self.getItemTemplate = function () {
            if (self.itemTemplate) {
                return self.itemTemplate;
            }

            if (self.showIcon) {
                return '../hmodules/components/h-select-list/h-select-list.item-with-icon.html';
            }

            if (self.showUserAvatar) {
                return '../hmodules/components/h-select-list/h-select-list.item-user-avatar.html';
            }

            if (self.showItemShift) {
                return '../hmodules/components/h-select-list/h-select-list.item-shift.html';
            }

            if (self.showBreakIcon) {
                return '../hmodules/components/h-select-list/h-select-list.item-with-break-icon.html';
            }

            return '../hmodules/components/h-select-list/h-select-list.item-default.html';
        };

        var sortItems = function () {
            if (self.sortBy && self.items) {
                if (self.isGrouped) {
                    self.items.forEach(function (group) {
                        group.items.sort(function (item1, item2) {
                            return item1[self.sortBy] > item2[self.sortBy] ? 1 : -1;
                        });
                    });
                } else {
                    self.items.sort(function (item1, item2) {
                        return item1[self.sortBy] > item2[self.sortBy]? 1: -1;
                    });
                }
            }
        };

        var updateVisibleItems = function () {
            self.visibleItems = [];

            try {
                if (self.items) {
                    for (var i in self.items) {
                        var isVisible = true;

                        if (self.isGrouped) {
                            const filteredGroupItems = [];
                            var group = self.items[i];
                            var isGroupVisible = false;
                            for (var j in group.items) {
                                if (self.search === 'Selected') {
                                    isVisible = !!group.items[j].selected;
                                } else if (self.search) {
                                    isVisible = group.items[j][self.textKey].toString().toLowerCase().indexOf(self.search.toLowerCase()) > -1;
                                }

                                group.items[j].visible = isVisible;

                                if (isVisible) {
                                    if (group.items[j].icon) {
                                        group.items[j].icon = Array.isArray(group.items[j].icon) ? group.items[j].icon : [group.items[j].icon];
                                    }
                                    filteredGroupItems.push(group.items[j]);
                                }
                                isGroupVisible = isGroupVisible || isVisible;
                            }

                            if (isGroupVisible) {
                                self.visibleItems.push({...group, items: filteredGroupItems});
                            }
                        } else {
                            if (self.search === 'Selected') {
                                isVisible = !!self.items[i].selected;
                            } else if (self.search) {
                                isVisible = self.items[i][self.textKey] && self.items[i][self.textKey].toString().toLowerCase().indexOf(self.search.toLowerCase()) > -1;
                            }

                            self.items[i].visible = isVisible;
                            if (isVisible) {
                                if (self.items[i].icon) {
                                    self.items[i].icon = Array.isArray(self.items[i].icon) ? self.items[i].icon : [self.items[i].icon];
                                }
                                self.visibleItems.push(self.items[i]);
                            }
                        }
                    }
                }

                self.viewTrigger = !self.viewTrigger;
            }
            catch (e) {
                console.error(e);
            }
        };

        self.assignHandlers = function (element) {
            element.find("li").on("click", function () {
                $timeout(() => {
                    var clickedElm = $(this);
                    var isAll = clickedElm.data("all-option");
                    if (isAll) {
                        self.selectAll();
                    }
                    else {
                        var index = clickedElm.data("order");
                        if (self.isGrouped) {
                            var groupIndex = clickedElm.data("group");
                            self.itemClicked(self.visibleItems[groupIndex].items[index]);
                        } else {
                            self.itemClicked(self.visibleItems[index]);
                        }
                    }
                    self.viewTrigger = !self.viewTrigger;
                });
            });
        };

        self.itemClicked = function (item) {
            if (self.ngDisabled) {
                return;
            }

            if (self.multi) {
                if (!angular.isArray(self.ngModel)) {
                    self.ngModel = [];
                }

                var wasSelected = false;
                var wasSelectedIndex;

                for (var i in self.ngModel) {
                    if (isEqual(item, self.ngModel[i])) {
                        wasSelected = true;
                        wasSelectedIndex = i;
                    }
                }
                if (wasSelected) {
                    self.ngModel.splice(wasSelectedIndex, 1);
                }
                else {
                    if (canSelectItem(item)) {
                        self.ngModel.push(item);
                    }
                }
            }
            else {
                if (canSelectItem(item)) {
                    self.ngModel = item;
                    self.close();
                }
            }

            matchSelectedWithModel();

            if (self.multi) {
                updateAllSelected();
            }

            if (canSelectItem(item)) {
                triggerChange(item);
            }
        };

        self.searchItems = function () {
            updateVisibleItems();
        };

        self.close = function () {
            self.search = '';
            updateVisibleItems();
            self.isOpen = false;

            if (self.appendTo) {
                menuElm?.remove();
            }

            $(document).off("click.h-select-list");
            document.removeEventListener('click', clickOutListener);
            self.onOpenStateChange && self.onOpenStateChange({isOpen: self.isOpen});
        };

        self.open = function (event) {
            if (self.ngDisabled) {
                return;
            }

            if (!self.loading) {
                if (event) {
                    skipClickEvent = true;
                }

                setTimeout(() => {
                    document.addEventListener('click', clickOutListener);
                    skipClickEvent = false;
                });
                self.focusedIndex = -1;
                self.focusedGroup = -1;
                self.isOpen = true;
                self.onOpenStateChange && self.onOpenStateChange({isOpen: self.isOpen});
                matchSelectedWithModel();

                if (self.appendTo) {
                    const hostElm = document.querySelector(self.appendTo);
                    menuElm ??= $element[0].querySelector('.selector-list');

                    const hostElmRect = hostElm.getBoundingClientRect();
                    const toggleRect = $element[0].getBoundingClientRect();

                    const scrollbarWidth = hostElm.offsetWidth - hostElm.clientWidth;

                    hostElm.appendChild(menuElm);

                    menuElm.style.width = `${toggleRect.width}px`
                    menuElm.style.top = `${toggleRect.top - hostElmRect.top + hostElm.scrollTop + toggleRect.height}px`;
                    menuElm.style.right = `${hostElmRect.right - toggleRect.right - scrollbarWidth}px`;
                }

                if (self.multi) {
                    updateAllSelected();
                }

                $timeout(function () {
                    $(document).on("click.h-select-list", function (event) {

                        if ($element.has(event.target).length === 0 && $(event.target).is(":visible") && !menuElm?.contains(event.target)) {
                            // This is a click outside the component, close it
                            self.close();
                            $scope.$digest();
                        }
                    });

                    if (!self.multi) {
                        var elementSelected = $element.find(".selected");

                        if (elementSelected.length && !self.isPaginated) {
                            $timeout(function () {
                                $element.find(".inner-list").scrollTop(elementSelected.offset().top - elementSelected.parent().offset().top - 15);
                            }, 100);
                        }

                        if (self.ngModel) {
                            if (self.isGrouped) {
                                self.items.forEach(function (group, groupIndex) {
                                    var index = group.items.indexOf(self.ngModel);
                                    if (index > -1) {
                                        self.focusedIndex = index;
                                        self.focusedGroup = groupIndex;
                                    }
                                });
                            } else {
                                self.focusedIndex = self.items.indexOf(self.ngModel);
                            }
                        }
                    }

                    $element.find("input[type='search']").focus();
                }, 100);
            }
        };

        var resetModelArray = function () {
            if (!angular.isArray(self.ngModel)) {
                self.ngModel = [];
            }
            self.ngModel.splice(0, self.ngModel.length);
        };

        self.onSelectAllKeyDown = function(event){
            if(event.keyCode === 13){ //enter
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                self.selectAll(self.noneOnAll);
            }
        };

        self.onDeSelectAllKeyDown = function(event){
            if(event.keyCode === 13){ //enter
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                self.unselectAll();
            }
        };

        self.selectAll = function (doClose) {
            if (self.multi) {
                resetModelArray();

                for (var i in self.items) {
                    if (self.isGrouped) {
                        self.items[i].items.forEach(function (item) {
                            if (self.noneOnAll) {
                                item.selected = false;
                            } else if (canSelectItem(item)) {
                                item.selected = true;
                                self.ngModel.push(item);
                            }
                        });
                    } else {
                        if (self.noneOnAll) {
                            self.items[i].selected = false;
                        } else if (canSelectItem(self.items[i])) {
                            self.items[i].selected = true;
                            self.ngModel.push(self.items[i]);
                        }
                    }

                }

                self.search = '';
                updateVisibleItems();
                triggerChange(self.items);
                updateAllSelected();

                if (doClose) {
                    self.close();
                }
            }
        };

        self.unselectAll = function () {
            if (self.multi) {
                resetModelArray();

                for (var i in self.items) {
                    if (self.isGrouped) {
                        self.items[i].items.forEach(function (item) {
                            item.selected = false;
                        });
                    } else {
                        self.items[i].selected = false;
                    }
                }

                self.search = '';
                updateVisibleItems();
                triggerChange(self.items);
                updateAllSelected();
            }
        };

        self.showSelected = function () {
            self.search = 'Selected';
            updateVisibleItems();
        };

        self.clearSearch = function () {
            self.search = '';
            updateVisibleItems();
            self.ngChange({ items: [] });
            $element.find("input[type='search']").focus();
        };

        self.clearSelection = function () {
            if (!self.multi && self.ngModel) {
                triggerChange(self.ngModel);
                self.ngModel = null;
            }
            else {
                self.unselectAll();
            }

            matchSelectedWithModel();
        };

        var getPreviousVisibleIndex = function (index) {
            index = index || 0;
            var previousIndex = index - 1;
            return (previousIndex >= 0)? previousIndex: 0;
        };

        var getNextVisibleIndex = function (index) {
            index = index || 0;
            var nextIndex = index + 1;
            var maxIndex = self.visibleItems && self.visibleItems.length;

            maxIndex = maxIndex? (maxIndex - 1): 0;

            return nextIndex < maxIndex? nextIndex: maxIndex;
        };

        var updatePreviousGroupAndIndex = function (groupIndex, index) {
            groupIndex = (groupIndex > -1) ? groupIndex : 0;
            index = (index > -1) ? index : 0;

            if (index === 0) {
                var newGroupIndex = groupIndex - 1;
                self.focusedGroup = newGroupIndex >= 0 ? newGroupIndex : 0;
                self.focusedIndex = newGroupIndex >= 0 ? self.visibleItems[newGroupIndex].items.length - 1 :  0;
                return;
            }
            self.focusedGroup = groupIndex;
            self.focusedIndex = (index - 1 >= 0) ? index - 1 : 0;
        };

        var updateNextGroupAndIndex = function (groupIndex, index) {
            groupIndex = (groupIndex > -1) ? groupIndex : 0;
            index = (index > -1) ? index : 0;

            var maxIndex = self.visibleItems[groupIndex].items.length;
            var maxGroupIndex = self.visibleItems.length;

            if (index === maxIndex - 1 && groupIndex !== maxGroupIndex - 1) {
                self.focusedGroup = groupIndex + 1;
                self.focusedIndex = 0;
                return;
            }
            if (index !== maxIndex - 1) {
                self.focusedGroup = groupIndex;
                self.focusedIndex = index + 1;
                return;
            }
            self.focusedGroup = groupIndex;
            self.focusedIndex = index;
        };


        let clickOutListener = function (event) {
            if (skipClickEvent) {
                skipClickEvent = false;
                return;
            }

            if (!$element[0].contains(event.target) && !menuElm?.contains(event.target)) {
                self.close();
                $scope.$evalAsync();
            }
        };

        self.$postLink = function () {
            self.focusedIndex = -1;
            self.focusedGroup = -1;

            $element.on("keyup", function (event) {
                switch (event.keyCode) {
                    case 27: // Esc
                        if (self.isOpen) {
                            self.close();
                            $element.find(".h-select-list").focus();
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            $scope.$digest();
                        }
                }
            });

            $element.on("keydown", function (event) {
                switch (event.keyCode) {
                    case 38: // Up Arrow
                    case 39: // Right Arrow
                        if (self.isOpen) {
                            if (self.isGrouped) {
                                updatePreviousGroupAndIndex(self.focusedGroup, self.focusedIndex);
                            } else {
                                self.focusedIndex = getPreviousVisibleIndex(self.focusedIndex);
                            }
                            $timeout(function() {
                                var focusedElm = $element.find(".highlighted");

                                $element.find(".inner-list").animate({
                                    scrollTop: focusedElm.offset().top - focusedElm.parent().offset().top - 15
                                }, 50);
                            }, 1);
                        }
                        break;
                    case 40: // Down Arrow
                        if (!self.isOpen) {
                            self.open();
                        }
                    case 37: // Left Arrow
                        if (self.isOpen) {
                            if (self.isGrouped) {
                                updateNextGroupAndIndex(self.focusedGroup, self.focusedIndex);
                            } else {
                                self.focusedIndex = getNextVisibleIndex(self.focusedIndex);
                            }
                            $timeout(function() {
                                var focusedElm = $element.find(".highlighted");

                                $element.find(".inner-list").animate({
                                    scrollTop: focusedElm.offset().top - focusedElm.parent().offset().top - 15
                                }, 50);
                            }, 1);
                        }
                        break;
                    case 13: // Enter
                        if (self.isOpen) {
                            if ((!self.isGrouped && self.visibleItems[self.focusedIndex]) || (self.isGrouped && self.visibleItems[self.focusedGroup].items[self.focusedIndex])) {
                                self.itemClicked(self.isGrouped ? self.visibleItems[self.focusedGroup].items[self.focusedIndex] : self.visibleItems[self.focusedIndex]);
                                self.viewTrigger = !self.viewTrigger;
                                $element.find(".h-select-list").focus();
                                $scope.$apply();
                                return;
                            }
                        }
                        else {
                            self.open();
                        }
                        break;
                    default:
                        self.focusedIndex = 0;
                        self.focusedGroup = 0;
                        break;
                }

                $scope.$apply();
            });
        };

        self.$onDestroy = function () {
            self.close();
            $(document).off("click.h-select-list");
        };

        var loadUsersAvatars = function () {
            if (self.items && self.showUserAvatar) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        if (self.isGrouped) {
                            self.items.forEach(function (group) {
                                group.items.forEach(function (item) {
                                    handleAddingUserAvatar(item, brand);
                                });
                            });
                        } else {
                            self.items.forEach(function (item) {
                                handleAddingUserAvatar(item, brand);
                            });
                        }
                    });

            }
        };

        var handleAddingUserAvatar = function (item, brand) {
            var userId = parseInt(item.id);

            if (!isNaN(userId)) {
                if (TSUsersService.users[userId]) {
                    item.profile_image = TSUsersService.users[userId].profile_image;
                    item.profileImageURL = TSUsersService.users[userId].profileImageURL;
                } else {
                    TSUsersService.loadUsers(brand.id, [userId])
                        .then(function () {
                            if (TSUsersService.users[userId]) {
                                item.profile_image = TSUsersService.users[userId].profile_image;
                                item.profileImageURL = TSUsersService.users[userId].profileImageURL;
                                $scope.$evalAsync();
                            }
                        });
                }
            }
        };

        var triggerChange = function (items) {
            $timeout(function () {
                $element.find("input[type='text']").change();
                self.ngChange({ items: angular.isArray(items)? items: [items] });
            }, 100);
        };

        var isEqual = function (item1, item2) {
            return (self.itemKey && item2[self.itemKey] == item1[self.itemKey]) || item1 === item2;
        };

        var matchSelectedWithModel = function () {
            if (self.items) {
                for (var i in self.items) {
                    if (self.isGrouped) {
                        var selected = false;

                        if (self.multi) {
                            if (angular.isArray(self.ngModel)) {
                                for (var item of self.items[i].items) {
                                    selected = false;
                                    for (var j in self.ngModel) {
                                        if (isEqual(item, self.ngModel[j])) {
                                            selected = true;
                                            self.ngModel[j] = item;
                                        }
                                    }
                                    item.selected = selected;
                                }
                            }
                        } else {
                            for (var item of self.items[i].items) {
                                selected = false;
                                if (self.ngModel && isEqual(item, self.ngModel)) {
                                    self.ngModel = item;
                                    selected = true;
                                }
                                item.selected = selected;
                            }
                        }
                    } else {
                        var selected = false;

                        if (self.ngModel) {
                            if (self.multi) {
                                if (angular.isArray(self.ngModel)) {
                                    for (var j in self.ngModel) {
                                        if (isEqual(self.items[i], self.ngModel[j])) {
                                            selected = true;
                                            self.ngModel[j] = self.items[i];
                                        }
                                    }
                                }
                            } else {
                                if (isEqual(self.items[i], self.ngModel)) {
                                    self.ngModel = self.items[i];
                                    selected = true;
                                }
                            }

                        }

                        self.items[i].selected = selected;
                    }
                }
            }
        };

        var updateAllSelected = function () {
            self.allSelected = false;

            if (self.items?.length > 1) {
                self.allSelected = true;

                for (var i in self.items) {
                    if (self.isGrouped) {
                        var group = self.items[i];
                        for (var j in group.items) {
                            if (!group.items[j].selected) {
                                self.allSelected = false;
                                return;
                            }
                        }
                    } else {
                        if (!self.items[i].selected) {
                            self.allSelected = false;
                            break;
                        }
                    }
                }
            }
        };

        var canSelectItem = function (item) {
            return !(
                (
                    self.blockedKeys && self.blockedKeys.indexOf(item[self.itemKey]) > -1
                ) ||
                (
                    !item.selected && self.ngModel?.length >= self.maxSelectedItemsCount
                )
            );
        }

        self.onListReachBottom = async () => {
            try {
                if (!self.isPaginated || self.isLoadingMore || !self.onReachBottom) {
                    return;
                }
                self.isLoadingMore = true;
                let loadPromise = {};
                const promise = self.onReachBottom({'loadPromise': loadPromise}) || loadPromise['promise'];
                await promise;
                self.isLoadingMore = false;
                $scope.$evalAsync();
            } catch (err) {
                console.error(err);
            }
        };
    }
})();
